import { Box, Typography } from '@mui/material';
import { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { titleStyles } from '../../common/InfoSidebar/infoStyles';
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CustomGridApi } from '../../common/XTable/types';
import InfoComments from './InfoComments';
import InfoImages from './InfoImages';
import InfoMain from './InfoMain';
import InfoSubjects from './InfoSubjects';

interface InfoMoreProps {
 apiRef: MutableRefObject<CustomGridApi>;
 data: any;
}

const InfoMore = ({ apiRef, data }: InfoMoreProps) => {
 const { t } = useTranslation();
 return (
  <Box>
   <InfoMain apiRef={apiRef} data={data} />
   <Typography sx={titleStyles}>{t('results.subjects')}</Typography>
   <InfoSubjects data={data} />
   <InfoImages data={data} />
   <InfoComments rowId={data?.Id} />
  </Box>
 );
};

export default InfoMore;
